import auth0 from 'auth0-js';
import Promise from 'promise';
import { auth0 as config } from '../config';

class AuthService {
  auth0 = new auth0.WebAuth(config);
  auth0Authentication = new auth0.Authentication(config);

  start(phoneNumber) {
    return new Promise((resolve, reject) => {
      this.auth0.passwordlessStart({
          connection: 'sms',
          send: 'code',
          phoneNumber
        }, (err, res) => {
          if (err) {
            reject(err);
            return;
          }
          resolve(res);
        }
      );
    });
  }

  verify(phoneNumber, verificationCode) {
    return fetch(`https://${config.domain}/oauth/ro`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "client_id": "7CiAvfIIGh0KzDk6DMZLEzF4UL9x0uOk",
        "connection": "sms",
        "grant_type": "password",
        "username": phoneNumber,
        "password": verificationCode,
        "scope": "openid"
      })
    })
      .then((response) => response.json());
  }

  getFirebaseToken(auth0Token) {
    return new Promise((resolve, reject) => {
      this.auth0Authentication.delegation({
        'id_token': auth0Token,
        'grant_type': 'urn:ietf:params:oauth:grant-type:jwt-bearer',
        'scope': 'openid',
        'api': 'firebase'
      }, (error, result) => {
        if (error) {
          reject(error);
          return;
        }
        resolve(result);
      })
    })
  }

  getProfileInfo(auth0Token) {
    return new Promise((resolve, reject) => {
      this.auth0.client.userInfo(auth0Token, function(err, user) {
        if (err) {
          reject(err);
          return;
        }

        resolve(user);
      });
    });
  }
}

export default new AuthService();